/* =============================================================================
 * PDP "Add-ons" cluster — small config-driven multi add-on engine.
 *   • Screen protector — matched by selected DEVICE value.
 *   • MagSafe wallet  — matched by selected case COLOR value, gated to the
 *     supported devices, and hidden while personalization is applied.
 * Matches by option VALUE (locale-independent). CLS-safe: nothing appears from
 * the default/preselected variant — only after the shopper interacts. ?variant
 * deep-links are server-rendered by Liquid (visible at first paint, no shift).
 * ========================================================================== */
(function () {
  'use strict';

  function norm(s) { return String(s == null ? '' : s).trim().toLowerCase().replace(/\s+/g, ' '); }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var fmt = (window.__cartI18n && window.__cartI18n.moneyFormat) || '${{amount}}';
    var a = (Number(cents) / 100).toFixed(2).replace(/\.00$/, ''); /* "$15", not "$15.00" (owner, 17 Oct 2026) */
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, a.replace(/\B(?=(\d{3})+(?!\d))/g, ',')) /* "$1,000", as Liquid prints it (Oct 2026) */
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.floor(Number(cents) / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, a.replace('.', ','));
  }
  function selectedValuesFromDOM() {
    return Array.prototype.map.call(document.querySelectorAll('.ProductForm__SelectedValue'), function (el) { return el.textContent; });
  }
  function readMap(id) { var el = document.getElementById(id); if (!el) return {}; try { return JSON.parse(el.textContent || '{}'); } catch (e) { return {}; } }
  function personalized() { return !!document.querySelector('.personalize-product-btn--added'); }

  // Add to cart via XHR so it BYPASSES personalize-drawer.js's window.fetch wrapper,
  // which otherwise intercepts every /cart/add POST while personalization is active
  // and injects personalization onto it — breaking unrelated add-on adds.
  function cartAdd(payload) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.onload = function () { (xhr.status >= 200 && xhr.status < 300) ? resolve(xhr.responseText ? JSON.parse(xhr.responseText) : {}) : reject(new Error('cart/add ' + xhr.status)); };
      xhr.onerror = function () { reject(new Error('network')); };
      xhr.send(JSON.stringify(payload));
    });
  }

  function makeAddon(o) {
    if (!o.container || !o.map) return null;
    function innerHTML(e) {
      var was = (e.compare_at && e.compare_at > e.price)
        ? ' <span class="Price Price--compareAt Text--subdued">' + money(e.compare_at) + '</span>' : '';
      return '<div class="gc-sp-addon__inner">' +
          '<div class="gc-sp-addon__main" data-gc-sp-view data-href="' + o.url + '?variant=' + e.id + '" role="button" tabindex="0" aria-label="' + escapeHtml(o.title) + '">' +
            '<span class="gc-sp-addon__img" style="background-image:url(\'' + e.image + '\')"></span>' +
            '<span class="gc-sp-addon__info">' +
              '<span class="gc-sp-addon__title">' + escapeHtml(o.title) + '</span>' +
              '<span class="gc-sp-addon__price"><span class="Price">' + money(e.price) + '</span>' + was + '</span>' +
            '</span>' +
          '</div>' +
          '<button type="button" class="gc-sp-addon__btn" data-gc-sp-add data-variant="' + e.id + '">' +
            '<span class="gc-sp-addon__btn-label">' + escapeHtml(o.addLabel) + '</span>' +
            '<svg class="gc-sp-addon__arrow" width="16" height="12" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M6 7.5H15M15 7.5L11 4M15 7.5L11 11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>' +
          '</button>' +
        '</div>';
    }
    function pick(values) {
      if (o.deviceGate && !values.some(function (v) { return o.deviceGate.indexOf('|' + norm(v) + '|') !== -1; })) return null;
      if (o.noPersonalization && personalized()) return null;
      for (var k in o.map) {
        var hit = values.some(function (v) { var nv = norm(v); return o.contains ? nv.indexOf(k) !== -1 : nv === k; });
        if (hit) return o.map[k];
      }
      return null;
    }
    return {
      container: o.container,
      evaluate: function (values) {
        var e = pick(values);
        if (e) { o.container.innerHTML = innerHTML(e); o.container.hidden = false; }
        else { o.container.hidden = true; o.container.innerHTML = ''; }
      }
    };
  }

  var sp = document.querySelector('[data-gc-sp-addon]');
  var ms = document.querySelector('[data-gc-ms-addon]');
  var addons = [];
  if (sp) addons.push(makeAddon({ container: sp, map: readMap('gc-sp-map'), url: sp.getAttribute('data-sp-url'), title: sp.getAttribute('data-sp-title'), addLabel: sp.getAttribute('data-sp-add') || 'Add', contains: false, deviceGate: null, noPersonalization: false }));
  if (ms) addons.push(makeAddon({ container: ms, map: readMap('gc-ms-map'), url: ms.getAttribute('data-sp-url'), title: ms.getAttribute('data-sp-title'), addLabel: ms.getAttribute('data-sp-add') || 'Add', contains: true, deviceGate: ms.getAttribute('data-sp-devices'), noPersonalization: true }));
  addons = addons.filter(Boolean);
  if (!addons.length) return;

  function updateCluster() {
    var cluster = addons[0].container.closest('[data-gc-addons]');
    if (!cluster) return;
    var hasPersonalize = !!cluster.querySelector('.personalize-product-btn-wrap');
    var anyVisible = addons.some(function (a) { return !a.container.hidden; });
    cluster.hidden = (!hasPersonalize && !anyVisible);
  }

  var lastValues = selectedValuesFromDOM();
  function evaluateAll(values) { lastValues = values; addons.forEach(function (a) { a.evaluate(values); }); updateCluster(); }

  // Initial: leave server-rendered cards (no CLS). If personalization is already
  // applied on load, hide the MagSafe card.
  if (ms && personalized()) { ms.hidden = true; ms.innerHTML = ''; }
  updateCluster();

  // Arm on real interaction with the variant picker OR the personalize controls.
  var armed = false;
  function arm(e) {
    if (e.target.closest('[data-action="select-value"], .Popover__Value, .ProductForm__ColorSwatch, .ProductForm__SelectorButton, [data-open-personalize-drawer], [data-edit-personalization], [data-remove-personalization]')) armed = true;
  }
  document.addEventListener('click', arm, true);
  document.addEventListener('keydown', arm, true);

  document.addEventListener('variant:changed', function (ev) {
    if (!armed) return;
    var v = ev.detail && ev.detail.variant;
    evaluateAll(v && v.options ? v.options : selectedValuesFromDOM());
  });

  // MagSafe depends on personalization → re-evaluate when its state changes.
  var pwrap = document.querySelector('.personalize-product-btn-wrap');
  if (pwrap) new MutationObserver(function () { if (armed) evaluateAll(lastValues); }).observe(pwrap, { attributes: true, subtree: true, attributeFilter: ['class'] });

  // Clicks: "Add" → cart (spinner); card body → navigate (non-SEO).
  function inAddon(el) { return (sp && sp.contains(el)) || (ms && ms.contains(el)); }
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-gc-sp-add]');
    if (add && inAddon(add)) {
      e.preventDefault();
      var id = add.getAttribute('data-variant');
      if (!id || add.classList.contains('is-loading')) return;
      add.classList.add('is-loading'); add.disabled = true;
      cartAdd({ id: Number(id), quantity: 1 })
        .then(function () {
          if (window._gcInvalidateCart) { try { window._gcInvalidateCart(); } catch (e2) {} }
          if (window.refreshAndOpenCartDrawer) { window.refreshAndOpenCartDrawer(); }
          else { document.dispatchEvent(new CustomEvent('product:added', { bubbles: true })); }
          add.classList.remove('is-loading'); add.disabled = false;
        })
        .catch(function () { add.classList.remove('is-loading'); add.disabled = false; });
      return;
    }
    var view = e.target.closest('[data-gc-sp-view]');
    if (view && inAddon(view)) { e.preventDefault(); var href = view.getAttribute('data-href'); if (href) window.location.href = href; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var view = e.target.closest('[data-gc-sp-view]');
    if (view && inAddon(view)) { e.preventDefault(); var href = view.getAttribute('data-href'); if (href) window.location.href = href; }
  });
})();

/* Add-on explainers: keep every bubble inside the add-ons panel and the screen.
   A bubble is centered on its "?", so after a long title it ran past the screen edge (and, hidden or
   not, still widened the page). Each bubble is measured with no shift, then slid back inside the
   panel (16px clear of the screen edges) through --gc-tip-dx; the CSS moves the arrow the opposite
   way so it still points at the "?". A bubble with no room above the row flips below it. Works on
   coordinates only, so it is the same in left-to-right and right-to-left languages. */
(function () {
  'use strict';
  var EDGE = 16;
  function place(tip) {
    var b = tip.querySelector('.gc-sp-addon__tipbubble');
    if (!b) return;
    b.style.setProperty('--gc-tip-dx', '0px');
    var r = b.getBoundingClientRect();
    if (!r.width) return;
    var lo = EDGE, hi = document.documentElement.clientWidth - EDGE;
    var box = tip.closest('.gc-addons');
    if (box) {
      var p = box.getBoundingClientRect();
      if (p.width) { lo = Math.max(lo, p.left + 4); hi = Math.min(hi, p.right - 4); }
    }
    var dx = 0;
    if (r.right > hi) dx = hi - r.right;
    if (r.left + dx < lo) dx = lo - r.left;
    b.style.setProperty('--gc-tip-dx', Math.round(dx) + 'px');
  }
  function placeAll() {
    var tips = document.querySelectorAll('[data-gc-addon-tip]');
    for (var i = 0; i < tips.length; i++) place(tips[i]);
  }
  function flip(tip) {
    var b = tip.querySelector('.gc-sp-addon__tipbubble');
    if (!b) return;
    tip.classList.remove('gc-tip--below');
    var need = b.offsetHeight + 12;
    if (tip.getBoundingClientRect().top < need) tip.classList.add('gc-tip--below');
  }
  var queued = false;
  function soon() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; placeAll(); });
  }
  function onOpen(e) {
    var tip = e.target && e.target.closest ? e.target.closest('[data-gc-addon-tip]') : null;
    if (!tip) {
      var row = e.target && e.target.closest ? e.target.closest('.gc-sp-addon__main') : null;
      tip = row ? row.querySelector('[data-gc-addon-tip]') : null;
    }
    if (tip) { flip(tip); place(tip); }
  }
  document.addEventListener('pointerenter', onOpen, true);
  document.addEventListener('focusin', onOpen, true);
  document.addEventListener('click', onOpen, true);
  window.addEventListener('resize', soon);
  window.addEventListener('orientationchange', soon);
  window.addEventListener('load', soon);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(soon);
  /* rows are shown or re-rendered when the shopper picks a device or color */
  if (window.MutationObserver) {
    var panels = document.querySelectorAll('.gc-addons');
    var mo = new MutationObserver(soon);
    for (var i = 0; i < panels.length; i++) mo.observe(panels[i], { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'class'] });
  }
  placeAll();
})();
